import * as React from 'react';

import * as styles from './ServicePlacesMortgageBanner.css';
import mortgageIcon from './images/mortgage.svg';
import { IMortgagePropertyRates } from 'shared/types/mortgage/banksData';

export interface IServicePlacesMortgageBannerProps {
  position: number;
  onClick: () => void;
  rates: IMortgagePropertyRates;
}

export const ServicePlacesMortgageBanner: React.FC<IServicePlacesMortgageBannerProps> = ({
  onClick,
  position,
  rates,
}) => {
  return (
    <a
      target="_blank"
      rel="noreferrer"
      href={`https://cian.ru/ipoteka-main?banner=servisnoe_mesto_oldstyle_${position}`}
      className={styles['wrapper']}
      onClick={onClick}
    >
      <div className={styles['container']}>
        <img className={styles['logo']} src={mortgageIcon} alt="Циан.Ипотека" />
        <div className={styles['content']}>
          <h3 className={styles['title']}>Выгодные ставки по ипотеке</h3>
          <p className={styles['text']}>
            {rates.newBuilding}% на новостройки и {rates.used}% на вторичку
          </p>
          <button className={styles['button']}>Узнать свои ставки</button>
        </div>
      </div>
    </a>
  );
};
